import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "antd";
import { fetchBranchList } from "./branchThunks";
import BranchList from "./components/BranchList";

const { Title } = Typography;

const BranchEntry = () => {
  const dispatch = useDispatch();
  const { branchList } = useSelector((s) => s.branchManage);


  useEffect(() => {
    dispatch(fetchBranchList());
  }, [dispatch]);

  return (
    <>
      <Title level={2}>Branch Entry</Title>
      <BranchList branches={branchList} />
    </>
  );
};

export default BranchEntry;
